import React from 'react';
import EfpaLink from '../../EfpaLink';
import efpaConfig from "../../../utils/efpaConfig";
// import PropTypes from 'prop-types';

const Footer = (props) => {
  return (
    <div className="Footer">
      {`© EFPA España ${new Date().getFullYear()} - `}
      <EfpaLink to={efpaConfig.PRIVACY_POLICIES_URL} className="Footer-link" mode="outsideLink">
        Aviso legal
      </EfpaLink>{' '}
      {/* - Aplicación desarrollada por{' '}
      <EfpaLink to="http://www.d9t.es" className="Footer-link" mode="outsideLink">
        D9 Tecnologies
      </EfpaLink>{' '}
      y{' '}
      <EfpaLink to="http://www.asolcon.com/" className="Footer-link" mode="outsideLink">
        ASOLCON
      </EfpaLink> */}
    </div>
  );
};

Footer.propTypes = {};

export default Footer;
